<!-- Mobile Header Bar -->
<div class="lg:hidden bg-white/80 dark:bg-slate-800/80 backdrop-blur-lg border-b border-gray-200 dark:border-slate-700 px-4 py-3 flex items-center justify-between shadow-sm">
  <!-- Logo y nombre -->
  <div class="flex items-center space-x-3">
    <div class="bg-purple-100 dark:bg-purple-900/30 p-2 rounded-xl">
      <img class="w-8 h-8" src="assets/logodr.png" alt="Logo ReliefApp" />
    </div>
    <div>
      <h1 class="font-mono text-xl font-bold text-purple-600 dark:text-purple-400">ReliefApp</h1>
      <p class="font-mono text-xs text-gray-500 dark:text-gray-400">Tu lugar seguro</p>
    </div>
  </div>

  <!-- Actions -->
  <div class="flex items-center space-x-3">
    <!-- Quick Support -->
    <a href="https://www.buymeacoffee.com/petrizcelaya" 
       target="_blank" 
       class="p-2 bg-purple-100 dark:bg-purple-900/30 rounded-xl hover:scale-105 transition-transform">
      <svg class="w-5 h-5 text-purple-600 dark:text-purple-400" fill="currentColor" viewBox="0 0 20 20">
        <path d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"/>
      </svg>
    </a>

    <!-- Menu Button -->
    <button (click)="setActive()" 
            class="relative p-2 bg-gradient-to-r from-purple-500 to-indigo-600 rounded-xl shadow-lg hover:shadow-xl transition-all group">
      <div class="relative w-6 h-6 flex flex-col justify-center items-center">
        <span class="block w-5 h-0.5 bg-white transition-all group-hover:rotate-45 group-hover:translate-y-1.5" [class.rotate-45]="active" [class.translate-y-1.5]="active"></span>
        <span class="block w-5 h-0.5 bg-white mt-1 transition-all" [class.opacity-0]="active"></span>
        <span class="block w-5 h-0.5 bg-white mt-1 transition-all group-hover:-rotate-45 group-hover:-translate-y-1.5" [class.-rotate-45]="active" [class.-translate-y-1.5]="active"></span>
      </div>
    </button>
  </div>
</div>

<!-- Mobile Menu Overlay -->
<div 
  [ngClass]="{'opacity-0 pointer-events-none': !active, 'opacity-100': active}" 
  class="lg:hidden fixed inset-0 z-50 bg-gradient-to-br from-purple-900/95 via-indigo-900/95 to-slate-900/95 backdrop-blur-lg transition-all duration-300"
>
  <!-- Close Button -->
  <button (click)="setActive()" 
          class="absolute top-6 right-6 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition-colors">
    <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
    </svg>
  </button>

  <!-- Menu Content -->
  <div class="flex flex-col items-center justify-center h-full px-8">
    <!-- User Profile -->
    <div class="text-center mb-12">
      <div class="relative mb-4">
        <img class="w-24 h-24 rounded-full border-4 border-white/20 shadow-xl" 
             [src]="user?.photoURL ? user!.photoURL : 'assets/draw.png'" 
             alt="user photo" />
        <div class="absolute -bottom-2 -right-2 w-6 h-6 bg-green-500 rounded-full border-2 border-white"></div>
      </div>
      <a href="/profile" class="block">
        <h2 class="font-mono text-2xl text-white font-bold mb-1 hover:text-purple-200 transition-colors">
          {{user?.displayName ? user?.displayName : 'Usuario'}}
        </h2>
        <p class="font-mono text-purple-200 text-sm">Ver perfil</p>
      </a>
    </div>

    <!-- Navigation Menu -->
    <nav class="space-y-6 w-full max-w-xs">
      <a href="/home" 
         class="flex items-center justify-between w-full px-6 py-4 bg-white/10 backdrop-blur-sm rounded-2xl hover:bg-white/20 transition-all group">
        <div class="flex items-center space-x-4">
          <div class="w-10 h-10 bg-gradient-to-br from-purple-400 to-indigo-500 rounded-xl flex items-center justify-center">
            <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"/>
            </svg>
          </div>
          <span class="font-mono text-white text-lg font-medium">Daily</span>
        </div>
        <svg class="w-5 h-5 text-white/60 group-hover:text-white group-hover:translate-x-1 transition-all" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
        </svg>
      </a>

      <a href="/relief" 
         class="flex items-center justify-between w-full px-6 py-4 bg-white/10 backdrop-blur-sm rounded-2xl hover:bg-white/20 transition-all group">
        <div class="flex items-center space-x-4">
          <div class="w-10 h-10 bg-gradient-to-br from-indigo-400 to-purple-500 rounded-xl flex items-center justify-center">
            <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z" clip-rule="evenodd"/>
              <path d="M6 12a2 2 0 012-2h8a2 2 0 012 2v2a2 2 0 01-2 2H8a2 2 0 01-2-2v-2z"/>
            </svg>
          </div>
          <span class="font-mono text-white text-lg font-medium">Pensamientos</span>
        </div>
        <svg class="w-5 h-5 text-white/60 group-hover:text-white group-hover:translate-x-1 transition-all" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
        </svg>
      </a>
    </nav>

    <!-- Logout Button -->
    <button (click)="onLogOut()" 
            class="mt-12 px-8 py-3 bg-gradient-to-r from-red-500 to-pink-500 rounded-xl text-white font-mono font-medium hover:shadow-lg hover:scale-105 transition-all flex items-center space-x-2">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013 3v1"/>
      </svg>
      <span>Cerrar Sesión</span>
    </button>
  </div>
</div>

<!-- Desktop Sidebar -->
<aside class="hidden lg:flex fixed left-0 top-0 h-screen w-80 bg-gradient-to-b from-white via-purple-50/30 to-indigo-50/50 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 border-r border-purple-100 dark:border-slate-700 shadow-xl backdrop-blur-sm flex-col">
  
  <!-- Header -->
  <div class="p-6 border-b border-purple-100 dark:border-slate-700">
    <a href="/" class="flex items-center space-x-4 group">
      <div class="w-12 h-12 bg-purple-100 dark:bg-purple-900/30 rounded-2xl flex items-center justify-center group-hover:bg-purple-200 dark:group-hover:bg-purple-900/50 transition-all">
        <img class="w-8 h-8" src="assets/logodr.png" alt="Logo ReliefApp" />
      </div>
      <div>
        <h1 class="font-mono text-2xl font-bold text-purple-600 dark:text-purple-400 group-hover:text-purple-700 dark:group-hover:text-purple-300 transition-colors">ReliefApp</h1>
        <p class="font-mono text-sm text-gray-500 dark:text-gray-400">Tu lugar seguro</p>
      </div>
    </a>
  </div>

  <!-- User Profile -->
  <div class="p-6">
    <div class="bg-white/60 dark:bg-slate-800/60 backdrop-blur-sm rounded-2xl p-4 border border-purple-100 dark:border-slate-700">
      <div class="flex items-center space-x-4">
        <div class="relative">
          <img [src]="user?.photoURL ? user!.photoURL : 'assets/draw.png'" 
               alt="Avatar" 
               class="w-14 h-14 rounded-full border-3 border-purple-200 dark:border-purple-800 shadow-md">
          <div class="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white dark:border-slate-800"></div>
        </div>
        <div class="flex-1 min-w-0">
          <a href="/profile" class="block group">
            <h3 class="font-mono font-semibold text-gray-800 dark:text-gray-200 group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors truncate">
              {{user?.displayName ? user?.displayName : 'Usuario'}}
            </h3>
            <p class="font-mono text-sm text-gray-500 dark:text-gray-400">Ver perfil →</p>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Navigation -->
  <nav class="flex-1 px-6 pb-6">
    <ul class="space-y-3">
      <li>
        <a href="/home" 
           class="flex items-center space-x-4 px-4 py-3 rounded-xl hover:bg-gradient-to-r hover:from-purple-500 hover:to-indigo-600 hover:text-white transition-all duration-200 group hover:shadow-lg">
          <div class="w-10 h-10 bg-purple-100 dark:bg-purple-900/30 rounded-xl flex items-center justify-center group-hover:bg-white/20 transition-colors">
            <svg class="w-5 h-5 text-purple-600 dark:text-purple-400 group-hover:text-white" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"/>
            </svg>
          </div>
          <span class="font-mono font-medium text-gray-700 dark:text-gray-300 group-hover:text-white">Daily</span>
          <svg class="w-4 h-4 text-gray-400 group-hover:text-white/70 group-hover:translate-x-1 transition-all ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </a>
      </li>
      
      <li>
        <a href="/relief" 
           class="flex items-center space-x-4 px-4 py-3 rounded-xl hover:bg-gradient-to-r hover:from-indigo-500 hover:to-purple-600 hover:text-white transition-all duration-200 group hover:shadow-lg">
          <div class="w-10 h-10 bg-indigo-100 dark:bg-indigo-900/30 rounded-xl flex items-center justify-center group-hover:bg-white/20 transition-colors">
            <svg class="w-5 h-5 text-indigo-600 dark:text-indigo-400 group-hover:text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z" clip-rule="evenodd"/>
              <path d="M6 12a2 2 0 012-2h8a2 2 0 012 2v2a2 2 0 01-2 2H8a2 2 0 01-2-2v-2z"/>
            </svg>
          </div>
          <span class="font-mono font-medium text-gray-700 dark:text-gray-300 group-hover:text-white">Pensamientos</span>
          <svg class="w-4 h-4 text-gray-400 group-hover:text-white/70 group-hover:translate-x-1 transition-all ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </a>
      </li>

      <!-- Support -->
      <li class="pt-4">
        <div class="bg-gradient-to-r from-pink-100 to-purple-100 dark:from-pink-900/20 dark:to-purple-900/20 rounded-2xl p-4 border border-pink-200 dark:border-pink-800">
          <h4 class="font-mono text-sm font-semibold text-gray-800 dark:text-gray-200 mb-2">Apoya el proyecto</h4>
          <p class="font-mono text-xs text-gray-600 dark:text-gray-400 mb-3">Ayúdanos a mantener ReliefApp funcionando</p>
          <a href="https://www.buymeacoffee.com/petrizcelaya" 
             target="_blank" 
             class="inline-flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-xl text-sm font-mono hover:shadow-lg hover:scale-105 transition-all">
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"/>
            </svg>
            <span>Donar</span>
          </a>
        </div>
      </li>
    </ul>
  </nav>

  <!-- Footer -->
  <div class="p-6 border-t border-purple-100 dark:border-slate-700">
    <!-- Privacy Link -->
    <div class="mb-4">
      <a href="/privacy-policy"
         class="inline-flex items-center space-x-2 text-sm font-mono text-gray-500 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-400 transition-colors">
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
        </svg>
        <span>Aviso de Privacidad</span>
      </a>
    </div>
    
    <!-- Logout -->
    <button (click)="onLogOut()" 
            class="w-full flex items-center justify-center space-x-3 px-4 py-3 bg-gradient-to-r from-red-500 to-pink-500 text-white rounded-xl font-mono font-medium hover:shadow-lg hover:scale-105 transition-all">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013 3v1"/>
      </svg>
      <span>Cerrar Sesión</span>
    </button>
  </div>
</aside>